import view from "./view";
import previewView from "./previewView";
class resultsView extends view {
  _parentElement = document.querySelector(".results");
  _errorMessage = "No recipes found for your query! Please try again";
  _message = "";
  _searchResultsContainer = document.querySelector(".search-results");
  _collapseBtn = document.querySelector(".collapse--btn");
  _smallText = document.querySelector(".small-text");
  _collapseMenu = false;

  _generateMarkup() {
    return this._data
      .map((result) => previewView.render(result, false))
      .join("");
  }

  addHandlerCollapse() {
    this._searchResultsContainer.addEventListener(
      "click",
      function (e) {
        const btn = e.target.closest(".collapse--btn");

        if (!btn) return;
        this.toggleMenu(!this._collapseMenu);
      }.bind(this)
    );
  }

  toggleMenu(collapse) {
    this._collapseMenu = collapse;
    if (collapse) {
      this._searchResultsContainer.style.maxHeight = "0";
      this._collapseBtn.style.transform = "translate(-50%, 60%) rotate(0deg)";
      this._smallText.style.opacity = "0";
      this._parentElement.style.opacity = "0";
    } else {
      this._searchResultsContainer.style.maxHeight = "400px";
      this._collapseBtn.style.transform = "translate(-50%, 60%) rotate(180deg)";
      this._smallText.style.opacity = "1";
      this._parentElement.style.opacity = "1";
    }
  }

  constructor() {
    super();
    this.toggleMenu(this._collapseMenu);
  }
}

export default new resultsView();
